import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var commonQuestions = function commonQuestions(strictLocalize) {
  return {
    "1": {
      label: strictLocalize({
        id: "3ZArkx",
        defaultMessage: [{
          "type": 0,
          "value": "Die Lösung meines Problems dauerte zu lange"
        }]
      }),
      checked: false
    },
    "2": {
      label: strictLocalize({
        id: "l/NWQf",
        defaultMessage: [{
          "type": 0,
          "value": "Mitarbeiter*in war nicht hilfsbereit"
        }]
      }),
      checked: false
    },
    "3": {
      label: strictLocalize({
        id: "Ul1jJf",
        defaultMessage: [{
          "type": 0,
          "value": "Problem wurde nicht behoben"
        }]
      }),
      checked: false
    }
  };
};
var buildOtherQuestion = function buildOtherQuestion(strictLocalize) {
  return {
    label: strictLocalize({
      id: "KI6VQJ",
      defaultMessage: [{
        "type": 0,
        "value": "Sonstige"
      }]
    }),
    checked: false
  };
};
export var initQuestions = function initQuestions(strictLocalize, type) {
  if (type === "chat") {
    return _objectSpread(_objectSpread({}, commonQuestions(strictLocalize)), {}, {
      "4": {
        label: strictLocalize({
          id: "iagERT",
          defaultMessage: [{
            "type": 0,
            "value": "Für das Problem war Unterstützung per E-Mail nötig"
          }]
        }),
        checked: false
      },
      "5": buildOtherQuestion(strictLocalize)
    });
  } else {
    return _objectSpread(_objectSpread({}, commonQuestions(strictLocalize)), {}, {
      "4": buildOtherQuestion(strictLocalize)
    });
  }
};